export default [
  {
    path: '/knowledge/category',
    name: 'knowledge category admin list',
    component: () => import('@/views/KnowledgeBase/Admin/Category/List'),
    meta: {
      pageTitle: 'Knowledge Category',
      breadcrumb: [
        {
          text: 'Knowledge Category',
          active: true,
        },
      ],
    },
  },

  {
    path: '/knowledge/post',
    name: 'knowledge post admin list',
    component: () => import('@/views/KnowledgeBase/Admin/Post/List'),
    meta: {
      pageTitle: 'Knowledge Post',
      breadcrumb: [
        {
          text: 'Knowledge Post',
          active: true,
        },
      ],
    },
  },

  {
    path: '/knowledge/post/create',
    name: 'knowledge post create',
    component: () => import('@/views/KnowledgeBase/Admin/Post/Upsert'),
    meta: {
      pageTitle: 'Knowledge Post Create',
      breadcrumb: [
        {
          text: 'Knowledge Post Create',
          active: true,
        },
      ],
    },
  },

  {
    path: '/knowledge/post/:id/update',
    name: 'knowledge post update',
    component: () => import('@/views/KnowledgeBase/Admin/Post/Upsert'),
    meta: {
      pageTitle: 'Knowledge Post Upate',
      breadcrumb: [
        {
          text: 'Knowledge Post Update',
          active: true,
        },
      ],
    },
  },

  {
    path: '/knowledge-base/post',
    name: 'knowledge post list',
    component: () => import('@/views/KnowledgeBase/List'),
    meta: {
      pageTitle: 'Knowledge Base Posts',
      breadcrumb: [
        {
          text: 'Knowledge Base Posts',
          active: true,
        },
      ],
    },
  },

  {
    path: '/knowledge-base/post/:slug',
    name: 'knowledge post list',
    component: () => import('@/views/KnowledgeBase/Show'),
    meta: {
      pageTitle: 'Knowledge Base Post',
      breadcrumb: [
        {
          text: 'Knowledge Base Post',
          active: true,
        },
      ],
    },
  },

    {
        path: '/announcement',
        name: 'announcement admin list',
        component: () => import('@/views/Announcement/List'),
        meta: {
            pageTitle: 'Announcements',
            breadcrumb: [
                {
                    text: 'Announcements',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/announcement/create',
        name: 'announcement admin update',
        component: () => import('@/views/Announcement/Upsert'),
        meta: {
            pageTitle: 'Announcements',
            breadcrumb: [
                {
                    text: 'Announcement Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/announcement/:id',
        name: 'announcement admin update',
        component: () => import('@/views/Announcement/Upsert'),
        meta: {
            pageTitle: 'Announcements',
            breadcrumb: [
                {
                    text: 'Announcement Update',
                    active: true,
                },
            ],
        },
    },

]
